<template>
  <div class="animated fadeIn">
    <b-card>
      <b-form id="spkbForm" validated novalidate>
        <b-row>
          <b-col lg="12">
            <template>
              <b-row>
                <b-col sm="4">
                  <b-form-group label-for="driver" label="Driver">
                    <model-select
                      id="driver"
                      :options="listDriverEmployee"
                      v-model="pic"
                      required
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div v-if="pic === null" class="invalid-feedback-custom">
                      Employee harus di pilih.
                    </div>
                  </b-form-group>
                </b-col>

                <b-col sm="4">
                  <b-form-group label-for="date" label="Tanggal Pengiriman">
                    <v-date-picker
                      mode="range"
                      id="date"
                      required
                      :input-props="{
                        class: 'form-control',
                        placeholder: 'Tanggal Pengiriman',
                        required: '',
                        readonly: '',
                      }"
                      v-model="myDate"
                    ></v-date-picker>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12">
            <b-button
              size="sm"
              variant="stack-overflow"
              class="mr-1 btn-brand"
              @click="getDetail"
              :disabled="disabled"
            >
              <i class="fa fa-search"></i>
              <span>Filter</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <template >
      <global-table
          :table-data="listSpkb"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="bppForm"
          :redirect-detail="true"
          :show-add-button="false"
          caption="<i class='fa fa-align-justify'></i> Produk Listing"
          addButton="Tambah Produk"
          @editForm="editForm"
        ></global-table>
      <!-- <spkb-bpp-detail
        :loading="loading"
        :pic="pic"
        :spkb="listSpkb"
        :bpp-form="bppForm"
      ></spkb-bpp-detail> -->
    </template>

    <!-- <template v-else><loading></loading></template> -->
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import interfaces from "@/templates/_interfaces.js";
import { required, between } from "vuelidate/lib/validators";
import loading from "@/templates/Loading.vue";
import _ from "lodash";
import * as moment from "moment";
import "moment/locale/id";
import SpkbBpbDetail from "./SpkbBpbDetail";
import globalTable from "@/templates/Table.vue";

export default {
  name: "spkb-bpp",
  components: {
    ModelSelect,
    SpkbBpbDetail,
    loading,
    globalTable
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      listDriverEmployee: [],
      listDistributionCenter: [],
      listCustomerHoreka: [],
      listBank: [],
      pic: null,
      horeka: null,
      showHoreka: false,
      myDate: null,
      loading: false,
      listSpkb: [],
      total_all_payment: 0,
      totalRows: '0',
      bppForm: interfaces.bpp,
      fields: [
        { key: "spkb_number", sortable: true },
        { key: "spkb_bpb", label: "Status BPB", sortable: true },
        { key: "action", label: "Action", class: "text-center width-100" }
      ],
    };
  },
  computed: {
    disabled: function () {
      let temp1 = true;
      let temp2 = true;

      if (this.pic !== null && this.pic.value !== "49") {
        temp1 = false;
      } else if (this.pic !== null && this.pic.value === "49") {
        if (this.horeka === null) {
          temp1 = true;
        } else {
          temp1 = false;
        }
      }

      if (this.myDate !== null) {
        temp2 = false;
      } else {
        temp2 = true;
      }

      return temp1 === false && temp2 === false ? false : true;
    },
  },
  validations: {},
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    uniqueId: function (param = "") {
      return _.uniqueId(param);
    },
    getDetail: function () {
      this.loading = true;
      let start = moment(this.myDate.start).format("YYYY-MM-DD");
      let end = moment(this.myDate.end).format("YYYY-MM-DD");

      this.axios
        .post("web/spkb/spkb-bpb-list/", {
          pic: this.pic,
          delivery_start: start,
          delivery_end: end,
        })
        .then((response) => {
//          this.reset();
          this.listSpkb = response.data.data;

          // this.listSpkb = response.data.data;
          //  Object.entries(this.listSpkb).forEach((value, index) => {
          //   // let name = value[0].split(" - ");
          //   value[1].forEach((v, i) => {
          //     this.bppForm[v.order_id + "#" + v.product_id] = 0;
          //   });
          // });
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.expired(error, "");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
     editForm: function(a) {
      //this.resetForm();
      this.spkbForm = a;
    },
    expired: function (error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message,
        });
      }
    },
    back: function () {
      this.$router.go(-1);
    },
    getDropdownSpkb: function () {
      this.axios
        .get("web/dropdown/dropdown-spkb/")
        .then((response) => {
          this.listDriverEmployee = response.data.driver;
          this.listDistributionCenter = response.data.distribution_center;
          this.listCustomerHoreka = response.data.customer_horeka;
          this.listBank = response.data.bank;
        })
        .catch((error) => {})
        .finally(() => {
          //this.loading = false;
        });
    },
    onSelect: function (data) {
      if (data.value === "49") {
        this.showHoreka = true;
        this.horeka = null;
      } else {
        this.showHoreka = false;
        this.horeka = null;
      }
    },
    reset: function () {
      //this.paymentForm = interfaces.payment;
      this.paymentForm.action = [];
      (this.paymentForm.total_payment = []), (this.paymentForm.bank = null);
      this.paymentForm.payment_date = null;
      this.total_all_payment = 0;
    },
    updateTotal: function (newTotal) {
      this.total_all_payment = parseInt(newTotal);
    }
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.spkb_number = route[4];
    this.getDropdownSpkb();
  },
};
</script>

<style>
</style>